module.exports = __webpack_public_path__ + "img/welcome-bg.5e328cd5.png";